import { render } from "./selectedData.vue?vue&type=template&id=51ad6b00&scoped=true"
import script from "./selectedData.vue?vue&type=script&lang=js"
export * from "./selectedData.vue?vue&type=script&lang=js"

import "./selectedData.vue?vue&type=style&index=0&id=51ad6b00&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/tl-demo-web_v2.0.9.4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51ad6b00"]])

export default __exports__